import bn from 'bignumber.js'

bn.set({
  EXPONENTIAL_AT: 20,
  DECIMAL_PLACES: 80,
  // ROUNDING_MODE: bn.ROUND_HALF_UP,
})

export { bn }
